import { BooleanLike } from "~/api/_common/types"
import { RecruitmentStatus } from "~/api/_common/types-for-recruitment"

import { Company, CreateCompanyArgs } from "./Company"
import { CreatedEventScheduleArgs, EventSchedule } from "./EventSchedule"

export interface createEventArgs {
  id: number
  title: string
  content?: string
  selects_by_lottery?: BooleanLike
  thumbnail_img_url: string
  status: RecruitmentStatus
  url: string
  // created_at: string // 使われてない
  event_schedules?: CreatedEventScheduleArgs[]
  company: CreateCompanyArgs
}

export class Event {
  id: number
  title: string
  content?: string
  selectsByLottery?: BooleanLike | boolean
  thumbnailImgUrl: string
  status: RecruitmentStatus
  url: string
  // createdAt: string
  schedules?: EventSchedule[]
  company: Company

  constructor(args: createEventArgs) {
    this.id = args.id
    this.title = args.title
    this.content = args.content
    this.selectsByLottery = args.selects_by_lottery
    this.thumbnailImgUrl = args.thumbnail_img_url
    // this.createdAt = args.created_at
    this.schedules = args.event_schedules && args.event_schedules.map((schedule) => new EventSchedule(schedule))
    this.company = new Company(args.company)
    // computedメソッドで定義するとJSXで取得できないのでここで計算
    if (this.schedules === undefined || this.schedules.length === 0) {
      this.status = args.status
    } else {
      const filled = this.schedules.filter((schedule) => {
        return schedule.capacity > schedule.numberOfApplications
      })
      this.status = filled.length === 0 ? "filled" : args.status
    }
    this.url = args.url || ""
  }

  get sortedSchedules(): EventSchedule[] | undefined {
    if (this.schedules) {
      const beforeDeadlineSchedules = this.schedules.filter((schedule) => schedule.beforeEntryDeadline)
      const afterDeadlineSchedules = this.schedules.filter((schedule) => !schedule.beforeEntryDeadline)

      return beforeDeadlineSchedules.concat(afterDeadlineSchedules)
    }
  }
}
